import { Component } from '@angular/core';
import { ResetInitialPasswordComponent } from '@tango/app/login/reset-initial-password-form';

@Component({
  selector: 'bank-reset-initial-password-form',
  templateUrl: './reset-initial-password-form.component.html',
})
export class BankResetInitialPasswordComponent extends ResetInitialPasswordComponent {
  /**
   * Тестирует шаблон нового пароля.
   *
   * (?=(.*\d){2}) - must contain at least 2 digits
   * (?=.*[A-Z]) - must contain at least one upper case Latin letter
   * (.\S{7,}) - must be without whitespaces and at least 8 characters long
   *
   * @param password
   */
  testPasswordFormat(password: string): boolean {
    const regex = /^(?=(.*\d){2})(?=.*[A-Z])(.\S{7,})$/;
    return regex.test(password);
  }
}
